import React from 'react';

const Titles = () => (
    <div>
        <h1 className="title-container__title">Weather Finder</h1>
        <p>Find out Temperature, conditions and more...</p>
    </div>
);

export default Titles;


// WEBPACK FOOTER //
// ./src/components/Titles.js